export const environment = {
  production: false,
  googleMapsApiKey: 'AIzaSyCQh0PMPZbNQNkTZhPbI0Gow3aDLYeot94',
  path: 'fosil',
  endpoint: 'https://back-qa.brainloper.com/fosil',
  firebaseConfig: {
    apiKey: "AIzaSyAL0C93cHR4L2sDeg_4GL7GGddnHL5tgQU",
    authDomain: "fosil-qa.firebaseapp.com",
    projectId: "fosil-qa",
    storageBucket: "fosil-qa.appspot.com",
    messagingSenderId: "296731374014",
    appId: "1:296731374014:web:f007b4a1ad76368af549ef",
    measurementId: "G-RG9F4B86J8"
  },
  minimalScreen: 1200,
  idInventoryModule: 8,
  idRolMaintenanceManager: 3,
  linkBrainLoper: "https://brainloper.com/",
  idRolStorer: 6,
  idRolOperator: 4,
  publicKeyToken: 'BGSXwNhIfK9_TV4srptRIIkcdoZ4lrfToWY51bxo9P84uet32-80XlrEJ7bIolrmHY0sLtUgoyTD189rHEOAezA',
  createMaxDemandOT: 15,
  createMaxDemandOF: 15,
  urlTraccarWeb:"https://gps-qa.brainloper.com",
  urlGrafana:"https://back-qa.brainloper.com/grafana"
}
